export default {
  label: {
    aggregationText: 'Total de ',
  },
};
